import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

export const slideInOnlyUp = trigger('slideInOnlyUp', [
  state('in', style({ transform: 'translateX(0)' })),
  transition(':enter', [
    animate(
      '250ms ease-out',
      keyframes([
        style({ transform: 'translateY(100%)', opacity: 0 }),
        style({ transform: 'translateY(0)', opacity: 1 }),
      ])
    ),
  ]),
]);
